module.exports = __webpack_public_path__ + "files/72a42a97115a0ba0370b306c77bdee55.png";